import { render, staticRenderFns } from "./LabelEditor.vue?vue&type=template&id=5622c80d&scoped=true"
import script from "./LabelEditor.vue?vue&type=script&lang=ts"
export * from "./LabelEditor.vue?vue&type=script&lang=ts"
import style0 from "./LabelEditor.vue?vue&type=style&index=0&id=5622c80d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622c80d",
  null
  
)

export default component.exports